interface RankingItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: 'up' | 'down' | 'same';
}

const rankingData: RankingItem[] = [
  {
    rank: 1,
    title: '顶流男星深夜约会新晋小花',
    tag: '娱乐爆料',
    heat: '128 万热度',
    trend: 'up',
  },
  {
    rank: 2,
    title: '千万网红偷税被查涉案数千万',
    tag: '最新爆料',
    heat: '215 万热度',
    trend: 'up',
  },
  {
    rank: 3,
    title: '模范夫妻被曝已分居半年',
    tag: '娱乐爆料',
    heat: '102 万热度',
    trend: 'up',
  },
  {
    rank: 4,
    title: '热门综艺录制现场嘉宾翻脸',
    tag: '网友爆料',
    heat: '96 万热度',
    trend: 'same',
  },
  {
    rank: 5,
    title: '知名游戏主播贩卖外挂被曝光',
    tag: '网友爆料',
    heat: '189 万热度',
    trend: 'up',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500">
            实时热度排名，看看今天哪颗瓜最受关注
          </p>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingData.map((item, idx) => (
            <div
              key={item.title}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-200/50 transition-colors ${
                idx < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className="flex items-center justify-center w-8 h-8 flex-shrink-0">
                {item.rank <= 3 ? (
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-lg font-bold ${
                      item.rank === 1
                        ? 'bg-accent-500 text-background-50'
                        : item.rank === 2
                        ? 'bg-accent-300 text-accent-900'
                        : 'bg-accent-200 text-accent-800'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-semibold text-foreground-400">
                    {item.rank}
                  </span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.trend === 'up' && (
                    <span className="text-xs text-accent-600 flex items-center gap-0.5">
                      <i className="ri-arrow-up-line"></i>飙升
                    </span>
                  )}
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 truncate">
                  <strong>{item.title}</strong>
                </h3>
              </div>

              <div className="flex items-center gap-2 text-xs text-foreground-400 flex-shrink-0">
                <i className="ri-fire-line text-accent-500"></i>
                <span className="whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5 text-center">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-secondary-100 text-secondary-700 text-sm font-medium hover:bg-secondary-200 transition-colors cursor-pointer">
            <i className="ri-arrow-down-line"></i>
            <span>查看完整榜单</span>
          </div>
        </div>
      </div>
    </section>
  );
}